import moment from 'moment';

export function regroupePeriodeCollees(periodeAAjouter, periodes) {
  const indexPeriodeColleeDateFin = periodes.findIndex((el) => {
    return moment(el.dateDebut).subtract(1, 'days').isSame(periodeAAjouter.dateFin, 'day')
    && el.produitLocationNum.id === periodeAAjouter.produitLocationNum.id
      && periodeAAjouter.saturation === el.saturation;
  });
  if (indexPeriodeColleeDateFin !== -1) {
    periodeAAjouter.dateFin = periodes[indexPeriodeColleeDateFin].dateFin;
    periodes.splice(indexPeriodeColleeDateFin, 1);
  }
  const indexPeriodeColleeDateDebut = periodes.findIndex((el) => {
    return moment(el.dateFin).add(1, 'days').isSame(periodeAAjouter.dateDebut, 'day')
    && el.produitLocationNum.id === periodeAAjouter.produitLocationNum.id
      && periodeAAjouter.saturation === el.saturation;
  });
  if (indexPeriodeColleeDateDebut !== -1) {
    periodeAAjouter.dateDebut = periodes[indexPeriodeColleeDateDebut].dateDebut;
    periodes.splice(indexPeriodeColleeDateDebut, 1);
  }
  return periodeAAjouter;
}

// Ajoute une période dans le tableau de période du produit
// Si la période ajoutée jouxte une période existante
// alors il y a regroupement
export function periodeHelper(periodeAAjouter, periodes) {
  let positionDate = 0;
  const periodeProduit = periodes.find((el) => {
    if (moment(el.dateFin).add(1, 'days').isSame(periodeAAjouter.dateDebut, 'day')
      && periodeAAjouter.produitLocationNum.id === el.produitLocationNum.id
    && periodeAAjouter.saturation === el.saturation) {
      positionDate = 1;
      return el;
    }
    if (moment(el.dateDebut).subtract(1, 'days').isSame(periodeAAjouter.dateFin, 'day')
      && periodeAAjouter.produitLocationNum.id === el.produitLocationNum.id
      && periodeAAjouter.saturation === el.saturation) {
      positionDate = -1;
      return el;
    }
    return '';
  });

  if (periodeProduit) {
    if (positionDate === 1) {
      periodeProduit.dateFin = periodeAAjouter.dateDebut.clone();
    } else if (positionDate === -1) {
      periodeProduit.dateDebut = periodeAAjouter.dateFin.clone();
    }
    regroupePeriodeCollees(periodeProduit, periodes);
    return true;
  }
  return false;
}

export function preparationSuppressionDate(periodes, periodeAAjouter) {
  let index;
  periodes.forEach((el) => {
    if (el.dateDebut.isSame(periodeAAjouter.dateDebut, 'day')) {
      index = -1;
    } else if (el.dateFin.isSame(periodeAAjouter.dateFin, 'day')) {
      index = 1;
    } else if (periodeAAjouter.dateDebut.isBetween(el.dateDebut, el.dateFin, 'day', '[]')) {
      index = 0;
    }
  });
  return index;
}

export function deletePeriode(periodes, periodeAAjouter, index) {
  const periodeFocus = periodes.filter((el) => {
    return periodeAAjouter.dateDebut.isBetween(el.dateDebut, el.dateFin, 'day', '[]');
  });
  periodeFocus.forEach((periode) => {
    if (index === -1 && !periode.dateDebut.isSame(periode.dateFin, 'day')) {
      periode.dateDebut = moment(periode.dateDebut).add(1, 'days');
    } else if (index === 1 && !periode.dateDebut.isSame(periode.dateFin, 'day')) {
      periode.dateFin = moment(periode.dateFin).subtract(1, 'days');
    } else if (index === 0) {
      const indexASuprimer = periodes.findIndex(p => p === periode);
      periodes.splice(indexASuprimer, 1);
      const periodeA = {
        dateDebut: periode.dateDebut.clone(),
        dateFin: moment(periodeAAjouter.dateFin).subtract(1, 'days'),
        produitLocationNum: periode.produitLocationNum,
        prix: null,
      };
      const periodeB = {
        dateDebut: moment(periodeAAjouter.dateDebut).add(1, 'days'),
        dateFin: periode.dateFin.clone(),
        produitLocationNum: periode.produitLocationNum,
        prix: null,
      };
      periodes.push(periodeA, periodeB);
    } else {
      const indexASuprimer = periodes.findIndex(
        (el) => el.dateDebut.isSame(periodeAAjouter.dateDebut, 'day')
        && el.dateFin.isSame(periodeAAjouter.dateFin, 'day'),
      );
      periodes.splice(indexASuprimer, 1);
    }
  });
}

// Cette méthode part du principe que la vente passée en parametre
// a une date de debut === date de fin (cas d'un clic sur une case)
export function PeriodeDejaPresente(periodeAAjouter, periodes) {
  return periodes.find((el) => moment(periodeAAjouter.dateDebut).isBetween(el.dateDebut, el.dateFin, 'day', '[]'));
}
